import * as React from "react";

import { makeContainer } from "@client/content/Containers/container";
import { getContainerProps, getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { TargetSelector } from "@client/selectors";
import classNames from "classnames";
import makeButton, { type ButtonContainerPropsBase } from "./Base/container";

import "./style.less";

export type Props = RootContainerProps & {
  className: string;
};

const Content = makeButton<ButtonContainerPropsBase>(TargetSelector.Entity, undefined, {
  captionPropPath: "",
  excludeMargin: true
});

const Container = makeContainer(["padding"]);
export default ({ className, ...props }: Props) => (
  <Container className={classNames(className, "wsc_content_button")} {...getContainerProps(props)}>
    <Content {...getRootContainerProps(props)} />
  </Container>
);
